import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
  IDecision,
  IGetProgressResponse,
  IProgressUsefulWeeks,
  ISaveProgresOrgChart,
} from '../model/decide.model';
import { IOrganizationNode } from '../../../../../core/layout/components/organization-chart/models/organization-chart.types';
import config from '../../../../../../config.js';

@Injectable({
  providedIn: 'root',
})
export class DecideService {
  baseUrl = config.API_GATEWAY_ENDPOINT;

  constructor(private http: HttpClient) {}

  getListOfDecisions(scenarioId: string): Promise<IDecision[]> {
    const decisions = lastValueFrom(
      this.http.get<IDecision[]>(`${this.baseUrl}/decide/${scenarioId}`)
    );
    return decisions;
  }

  saveProgresOrgChart(
    selectedDecision: IDecision,
    checkedNodes: IOrganizationNode[],
    prid: string,
    scenarioId: string
  ): Promise<ISaveProgresOrgChart> {
    const usersNodes = checkedNodes.map((node) => node.sk_user);
    const response = lastValueFrom(
      this.http.post<ISaveProgresOrgChart>(
        `${this.baseUrl}/decide/simple-score`,
        {
          decision_sk: selectedDecision.sk,
          user_sks: usersNodes,
          scenario_id: scenarioId,
          user_id: prid,
        }
      )
    );
    return response;
  }

  saveUsefulWeeks(
    user_id: string,
    scenario_id: string,
    weekProgress: IProgressUsefulWeeks
  ): Promise<any> {
    const response = lastValueFrom(
      this.http.post(`${this.baseUrl}/decide/useful-weeks`, {
        weekProgress,
        scenario_id,
        user_id,
      })
    );
    return response;
  }

  getCredibility(prid: string, scenarioId: string): Promise<number> {
    const credibility = lastValueFrom(
      this.http.get<number>(
        `${this.baseUrl}/decide/credibility/${prid}/${scenarioId}`
      )
    );
    return credibility;
  }

  getProgress(
    prid: string,
    scenarioId: string
  ): Promise<IGetProgressResponse | null> {
    const progress = lastValueFrom(
      this.http.get<IGetProgressResponse>(
        `${this.baseUrl}/decide/progress/${prid}/${scenarioId}`
      )
    );
    return progress;
  }

  getProgressUsefulWeeks(
    prid: string,
    scenarioId: string
  ): Promise<IProgressUsefulWeeks> {
    const response = lastValueFrom(
      this.http.get<IProgressUsefulWeeks>(
        `${this.baseUrl}/decide/useful-weeks/${prid}/${scenarioId}`
      )
    );
    return response;
  }
}
